import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { md3 } from "vuetify/blueprints";

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    blueprint: md3,

    // Custom theme configuration
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          colors: {
            primary: "#264A7A",
            secondary: "#4c6ea0",
            surface: "#ffffff",
          },
        },
      },
    },
  });
  app.vueApp.use(vuetify);

  // Prevent browsers from showing saved/autofill suggestions on inputs.
  // `autocomplete` is a native HTML attribute, not a Vuetify prop, so it
  // cannot be set via Vuetify's `defaults` system. This directive stamps
  // the attribute directly on the rendered <input>/<textarea> elements.
  // Uses "one-time-code" because Chrome/Safari ignore "off" since ~2023.
  app.vueApp.directive("no-autocomplete", {
    mounted(el: HTMLElement) {
      el.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>("input, textarea").forEach((input) => {
        input.setAttribute("autocomplete", "one-time-code");
      });
    },
    updated(el: HTMLElement) {
      el.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>("input, textarea").forEach((input) => {
        if (input.getAttribute("autocomplete") !== "one-time-code") {
          input.setAttribute("autocomplete", "one-time-code");
        }
      });
    },
  });
});
